import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, LoadingOverlay } from "@mantine/core";
import ActivitiesWrapper from "src/features/activityLog/ActivitiesWrapper";
const ActivitiesContainer = ({ isLoading, activities }) => {
    return (_jsxs(Box, { pos: "relative", display: "flex", flex: "1", children: [_jsx(LoadingOverlay, { visible: isLoading }), !isLoading && _jsx(ActivitiesWrapper, {})] }));
};
export default ActivitiesContainer;
